module.exports = __webpack_public_path__ + "img/logo-roboinu-card.fadd8cd4.svg";